export default {
	service: [
		"Tjeneste",
		"Arrangement",
		"Uttak",
		"Innskudd",
		"Vilkår og Betingelser",
		"Sertifikat",
		"Vanlige spørsmål",
		"Brukerveiledning",
		"VIP"
	],
	sign: {
		title: "Innlogget i {0} dag",
		SignIn: "Logg inn"
	},
	hotMusicAlbum: "Hot Music Album",
	hotMusic: "Hot Song Charts",
	popular: "Ny avspilling",
	rankings: "Populære filmer",
	top: "TOP{0}",
	OnchainServices: "Onchain-tjenester",
	Real: {
		title: "Sanntid",
		list: [
			"Totalt antall nettbrukere",
			"Gjennomsnittlig brukeroptimaliseringsvolum",
			"Optimaliseringsbehov Varmekart",
			"Plattformens kampanjeoptimaliseringsmengde"
		]
	},
	work: {
		title: "Belønning for innsending av bestilling",
		SignIn: "Få"
	},
	Profit: {
		Profit: "Fortjeneste",
		tabs: ["Fortjeneste", "Bonus", "Konto"],
		TotalBalance: "Total saldo",
		TotalLuckyBonus: "Total Lykkebonus",
		todayEarnings: "Dagens Inntekter",
		availableBalance: "Tilgjengelig saldo",
		title: ["Dagens Inntekter", "Totale Inntekter", "Konto"],
		list: ["Ordre Inntekter", "Team Inntekter", "Totale Inntekter"],
		order: {
			title: "Ordre Fortjeneste",
			commission: "Ordre Kommisjon"
		},
		Analysis: {
			title: "Fortjenesteanalyse",
			tips: "Du har gjennomført {0} transaksjoner",
			tabs: ["Dagens Fortjeneste", "Total Fortjeneste"],
			totalTitle: ["Ordre Fortjeneste", "Innsjekkingsfortjeneste", "Team Fortjeneste", "Bonus Fortjeneste"]
		}
	},
	CustomerService: {
		title: "Kundeservicesenter",
		consultation: "Kundeservicekonsultasjon",
		btn: "Kontakt oss",
		noticeTitle: "Systemmelding"
	},
	addWallet: "Legg til lommebok",
	taskProgress: "Daglig oppgaveprogresjon",
	currentProgress: "Nåværende oppgaveprogresjon",
	awardsBulletin: `{0} bruker vinner {1} {2} premie i oppgaven.`,
	vip: {
		title: "@:vip.title",
		more: "Vis mer"
	},
	stats: {
		title: "Datakilder - Dashboard og API",
		subTitle: "Artiststatistikk",
		list: ["Målinger", "Artister med aktive sosiale medier", "Oppdatert daglig"]
	}
};
